/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 *
 * Google CDN, Latest jQuery
 * To use the default WordPress version of jQuery, go to lib/config.php and
 * remove or comment out: add_theme_support('jquery-cdn');
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        $(document).ready(function() {
          setTimeout(function(){
            $('body').addClass('loaded');
          }, 3000);
        });
        $(document).ready(function() {
          //Initialize for inline images
          $('.pop').magnificPopup({type:'image'});
          //Initialize for wordpress galleries
          $('.gallery').magnificPopup({
            delegate: 'a',
            type: 'image',
            gallery: {
              enabled: true
            }
          });
        });
        // ===== Scroll to Top ====
        $(document).ready(function(){
         // $('body').append('');
          $(window).scroll(function () {
            if ($(this).scrollTop() >= 150) {
              $('#toTop').fadeIn();
            } else {
              $('#toTop').fadeOut();
            }
          });
          $('#toTop').click(function(){
            $("html, body").animate({ scrollTop: 0 }, 600);
            return false;
          });
        });
        (function ($) {
          $.fn.boltzVAlign = function() {
          return this.each(function(i){
              var ah = $(this).height();
              var ph = $(this).parent().height();
              var mh = Math.ceil((ph-ah) / 2);
              $(this).css('margin-top', mh);
            });
          };
        })(jQuery);
// car-overlay
        jQuery(document).ready(function($){
          $('i.boltzVA-parent').imagesLoaded( function() {
            $(".boltzVA-child").boltzVAlign();
          });
          $( window ).resize(function() {
              $(".boltzVA-child").boltzVAlign();
          });

        });
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
        $(document).ready(function() {
          var $item = $('.carousel .item');
          var $wHeight = $(window).height() - 70;
          $item.eq(0).addClass('active');
          // $item.height($wHeight);
          $item.addClass('full-screen');

          $('.carousel.item img').each(function() {
            var $src = $(this).attr('src');
            $(this).parent().css({
              'background-image' : 'url(' + $src + ')  no-repeat scroll center top',
              'max-height' : '410px',
              'height'  : '"' + $wHeight + '"'
            });
            $(this).remove();
          });

          $(window).on('resize', function (){
            $wHeight = $(window).height() - 70;
            // $item.height($wHeight);
          });
          $('.carousel').carousel({
            interval: 8000,
            pause: "false"
          });
        });
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
